import { ENTITY_TO_HINT_MAP } from './constants';

export const setHint = (entity: keyof typeof ENTITY_TO_HINT_MAP, id: string) => {
  ENTITY_TO_HINT_MAP[entity]!.set(id);
};

export const getHint = (entity: keyof typeof ENTITY_TO_HINT_MAP) => {
  const id = ENTITY_TO_HINT_MAP[entity]!.get();

  if (!id || typeof id === 'number') {
    return undefined;
  }

  return id;
};

export const reset = () => {
  window.TL.Context.reset();
};
